// Copyright (c) 2024-present, Dinocollab Technologies, Inc. and its affiliates. All rights reserved.

// imports
import { useMemo } from 'react'
import { GridItemDefault } from './ui.units'
import { getGridItemSizes, resolveGridNearEndThreshold, resolveGridScrollingThreshold, resolveGridSpacing } from './helpers'
// types
import type { IViewGridConfig, IViewGridProps } from './types'

/** Merges the provided props and config into a single configuration object. */
export const useMergedConfig = <T>(props: IViewGridProps<T>, config: IViewGridConfig<T>) => {
  return useMemo(() => {
    return {
      spacing: resolveGridSpacing(props.spacing, config.spacing),
      scrollingThreshold: resolveGridScrollingThreshold(props.scrollingThreshold, config.scrollingThreshold),
      nearEndThreshold: resolveGridNearEndThreshold(props.nearEndThreshold, config.nearEndThreshold),
      sizes: getGridItemSizes(props.sizes ?? config.sizes),
      Component: props.Component ?? config.Component ?? GridItemDefault,
      normalOptions: Object.assign({ autoHeight: false }, config.normalOptions, props.normalOptions),
      virtualizedOptions: Object.assign({ overscan: 4 }, config.virtualizedOptions, props.virtualizedOptions)
    }
  }, [props, config])
}
